import { useMutation } from '@tanstack/react-query';
import { forgotPassword } from './api';

export const useForgotPasswordMutation = () => useMutation({ mutationFn: forgotPassword });
